module.exports = __webpack_public_path__ + "img/honor_004.1cccab4.png";